import { useCallback, useState } from 'react'
import { VisibilityAdornmentProps } from '@/components/ui/VisibilityAdornment/VisibilityAdornment.types'

export const useVisibilityAdornment = ({ initialValue, onShow, onHide }: VisibilityAdornmentProps) => {
  const [isLoading, setIsLoading] = useState(false)
  const [isVisible, setIsVisible] = useState(initialValue)

  const onClick = useCallback(async () => {
    try {
      setIsLoading(true)
      await (isVisible ? onHide : onShow)?.()
      setIsVisible((value) => !value)
    } finally {
      setIsLoading(false)
    }
  }, [isVisible, onShow])

  return {
    onClick,
    isLoading,
    isVisible,
  }
}
